import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/superadmin/login",
    name: "superadminLogin",
    component: () => import("../components/superadmin/auth/Login"),
  },
  {
    path: "/superadmin/forgotPassword",
    name: "superadminForgotPassword",
    component: () => import("../components/superadmin/auth/ForgotPassword"),
  },
  {
    path: "/superadmin/resetPassword/:token",
    name: "superadminResetPassword",
    component: () => import("../components/superadmin/auth/ResetPassword"),
  },
  {
    path: "/privacy-policy",
    name: "superadminPrivacy",
    component: () => import("../components/superadmin/auth/Privacy-policy"),
  },
  {
    path: "/term-condition",
    name: "superadminTerm",
    component: () => import("../components/superadmin/auth/Terms-condition"),
  },
  {
    path: "/superadmin/",
    name: "superadminHome",
    component: () => import("../components/superadmin/layouts/layout"),
    children: [
      {
        path: "changePassword",
        name: "superadminChangePassword",
        component: () => import("../components/superadmin/auth/ChangePassword"),
      },
      {
        path: "profile",
        name: "superadminProfile",
        component: () => import("../components/superadmin/Profile"),
      },
      {
        path: "society/requests",
        name: "superadminSocietyRequests",
        component: () => import("../components/superadmin/society/Requests"),
      },
      {
        path: "society/requests/:id/details",
        name: "superadminSocietyRequestDetails",
        component: () =>
          import("../components/superadmin/society/AcceptRejectRequest"),
      },
      {
        path: "society/list",
        name: "superadminSocietyList",
        component: () => import("../components/superadmin/society/List"),
      },
      {
        path: "society/edit/:id",
        name: "superadminSocietyEdit",
        component: () => import("../components/superadmin/society/Edit"),
      },
      {
        path: "society/list/:id/details",
        name: "superadminSocietyDetail",
        component: () => import("../components/superadmin/society/Details"),
      },
      {
        path: "society/list/:id/member/:member_id",
        name: "superadminSocietyMemberDetails",
        component: () => import("../components/superadmin/society/Member"),
      },
      {
        path: "modules",
        name: "superadminModules",
        component: () => import("../components/superadmin/Modules"),
      },
      {
        path: "feedback",
        name: "superadminModules",
        component: () => import("../components/superadmin/Feedback"),
      },
      {
        path: "plan",
        name: "superadminModules",
        component: () => import("../components/superadmin/society/plan/list"),
      },
      {
        path: "plan/add",
        name: "superadminModules",
        component: () => import("../components/superadmin/society/plan/add"),
      },
      {
        path: "plan/edit/:id",
        name: "superadminModules",
        component: () => import("../components/superadmin/society/plan/edit"),
      },
      {
        path: "payment",
        name: "superadminModules",
        component: () => import("../components/superadmin/Payment"),
      },
      {
        path: "privacy",
        name: "superadminModules",
        component: () => import("../components/superadmin/PrivacyPolicy"),
      },

      {
        path: "term_condition",
        name: "superadminModules",
        component: () => import("../components/superadmin/TermsCondition"),
      },

      {
        path: "dashboard",
        name: "superadminDashboard",
        component: () => import("../components/superadmin/Dashboard"),
      },
      {
        path: "society/add",
        name: "superadminSocietyAdd",
        component: () => import("../components/superadmin/society/Add"),
      },
    ],
  },

  {
    path: "/superadmin/404",
    name: "superadmin404",
    component: () => import("../components/superadmin/404"),
  },

  {
    path: "*",
    name: "notfound",
    component: () => import("../components/404"),
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

router.beforeEach((to, from, next) => {
  let isAuthenticated = false;
  let role;
  let user = localStorage.getItem("user");

  if (user) {
    isAuthenticated = true;
    user = JSON.parse(user);
    role = user.role;
  }

  const NonAuthRoutesForSuperAdmin = [
    "superadminLogin",
    "superadminForgotPassword",
    "superadminResetPassword",
  ];
  const NonAuthRoutesForSocietyAdmin = [
    "societyadminLogin",
    "societyadminVerifyOtp",
  ];

  const CmsRoute =[
    "superadminPrivacy",
    "superadminTerm"
  ]
if(CmsRoute.includes(to.name)){
  next();
  return;
}
  if (NonAuthRoutesForSuperAdmin.includes(to.name) && !isAuthenticated) {
    next();
    return;
  } else if (NonAuthRoutesForSocietyAdmin.includes(to.name) && !isAuthenticated) {
    next();
    return;
  }

  if (
    !NonAuthRoutesForSuperAdmin.includes(to.name) &&
    !isAuthenticated &&
    to?.path?.startsWith("/superadmin")
  ) {
    next({ path: "/superadmin/login" });
    return;
  } else if (
    !NonAuthRoutesForSocietyAdmin.includes(to.name) &&
    !isAuthenticated &&
    to?.path?.startsWith("/societyadmin")
  ) {
    next({ path: "/societyadmin/login" });
    return;
  }

  if (
    NonAuthRoutesForSuperAdmin.includes(to.name) &&
    isAuthenticated &&
    role == "superadmin"
  ) {
    next({ path: "/superadmin/dashboard" });
    return;
  } else if (
    NonAuthRoutesForSocietyAdmin.includes(to.name) &&
    isAuthenticated &&
    role == "societyadmin"
  ) {
    next({ path: "/societyadmin/dashboard" });
    return;
  }

  if (
    role == "superadmin" &&
    isAuthenticated &&
    to.path.startsWith("/superadmin/")
  ) {
    next();
    return;
  } else if (
    role == "societyadmin" &&
    isAuthenticated &&
    to.path.startsWith("/societyadmin/")
  ) {
    next();
    return;
  } else {
    // console.log(role);
    console.error("Route not found");
    console.log(role);
    next({ path: "/" + role + "/dashboard" });
  }
});

export default router;
